import optionsClient from '@/client/options/definition/options.client';
import { Option } from '@/data/data-models';
import { SCREEN_NAMES } from '@/data/constants/screen';

// option metadata
export default {
    addPreset: new Option({
        metadata: {
            name: 'addPreset',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: false,
        },

        component: 'add-preset',
    }),

    alignSelf: new Option({
        metadata: {
            name: 'alignSelf',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'align-self',
    }),

    aspectRatio: new Option({
        metadata: {
            name: 'aspectRatio',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew'],
            screens: [],
            isResponsive: true,
        },

        component: 'aspect-ratio',
    }),

    aspectRatioVideo: new Option({
        metadata: {
            name: 'aspectRatioVideo',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'aspect-ratio-video',
    }),

    backgroundColor: new Option({
        metadata: {
            name: 'backgroundColor',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isHiddenInput', 'smartColor'],
            screens: [],
            isResponsive: true,
        },

        component: 'background-color',
    }),

    backgroundDisplay: new Option({
        metadata: {
            name: 'backgroundDisplay',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'background-display',
    }),

    backgroundGradient: new Option({
        metadata: {
            name: 'backgroundGradient',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'background-gradient',
    }),

    backgroundImage: new Option({
        metadata: {
            name: 'backgroundImage',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'background-image',
    }),

    backgroundImageAttachment: new Option({
        metadata: {
            name: 'backgroundImageAttachment',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'background-image-attachment',
    }),

    backgroundImageRepeat: new Option({
        metadata: {
            name: 'backgroundImageRepeat',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'background-image-repeat',
    }),

    backgroundImageSize: new Option({
        metadata: {
            name: 'backgroundImageSize',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'background-image-size',
    }),

    backgroundImageOverlay: new Option({
        metadata: {
            name: 'backgroundImageOverlay',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'background-image-overlay',
    }),

    backgroundImageOverlayOpacity: new Option({
        metadata: {
            name: 'backgroundImageOverlayOpacity',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'background-image-overlay-opacity',
    }),

    backgroundImagePosition: new Option({
        name: 'backgroundImagePosition',
        metadata: {
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'background-image-position',
    }),

    border: new Option({
        metadata: {
            name: 'border',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'border',
    }),

    borderRadius: new Option({
        metadata: {
            name: 'borderRadius',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'border-radius',
    }),

    boxed: new Option({
        metadata: {
            name: 'boxed',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'boxed',
    }),

    boxShadow: new Option({
        metadata: {
            name: 'boxShadow',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew'],
            screens: [],
            isResponsive: false,
        },

        component: 'box-shadow',
    }),

    carouselControls: new Option({
        metadata: {
            name: 'carouselControls',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'carousel-controls-visibility',
    }),

    carouselSpeed: new Option({
        metadata: {
            name: 'carouselSpeed',
            lockedOption: false,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'carousel-speed',
    }),

    carouselTransitionEffect: new Option({
        metadata: {
            name: 'carouselTransitionEffect',
            lockedOption: false,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'carousel-transition-effect',
    }),

    carouselPromoDataSource: new Option({
        metadata: {
            name: 'carouselPromoDataSource',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'carousel-promo-data-source',
    }),

    color: new Option({
        metadata: {
            name: 'color',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'color',
    }),

    cookie: new Option({
        metadata: {
            name: 'cookie',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'cookie',
    }),

    cookieLoad: new Option({
        metadata: {
            name: 'cookieLoad',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'cookie-load',
    }),

    contentAlignment: new Option({
        metadata: {
            name: 'contentAlignment',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'content-alignment',
    }),

    cursor: new Option({
        metadata: {
            name: 'cursor',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: false,
        },

        component: 'option-cursor', // needs the "option-" prefix since "cursor" is a reserved keyword
    }),

    dataDynamic: new Option({
        metadata: {
            name: 'dataDynamic',
            lockedOption: true,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['topLevel'],
            screens: [SCREEN_NAMES.TEMPLATE_EDITOR],
            isResponsive: false,
        },

        component: 'data-dynamic',
    }),

    dateFormat: new Option({
        metadata: {
            name: 'dateFormat',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
        },

        component: 'date-format',
    }),

    disabled: new Option({
        metadata: {
            name: 'disabled',
            lockedOption: true,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: false,
        },

        component: 'disabled',
    }),

    drawerExpand: new Option({
        metadata: {
            name: 'drawerExpand',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'drawer-expand',
    }),

    drawerIconImage: new Option({
        metadata: {
            name: 'drawerIconImage',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'drawer-icon',
    }),

    dropdownAnchor: new Option({
        metadata: {
            name: 'dropdownAnchor',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'nav-dropdown-anchor',
    }),

    dropdownDirection: new Option({
        metadata: {
            name: 'dropdownDirection',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'nav-dropdown-direction',
    }),

    dropdownIcon: new Option({
        metadata: {
            name: 'dropdownIcon',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'nav-dropdown-icon',
    }),

    dropdownIconDisplay: new Option({
        metadata: {
            name: 'dropdownIconDisplay',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'nav-dropdown-icon-display',
    }),

    dropdownSpeed: new Option({
        metadata: {
            name: 'dropdownSpeed',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'nav-dropdown-speed',
    }),

    dropdownTrigger: new Option({
        metadata: {
            name: 'dropdownTrigger',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'nav-dropdown-trigger',
    }),

    dynamicCollection: new Option({
        metadata: {
            name: 'dynamicCollection',
            lockedOption: false,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'dynamic-collection',
    }),

    dynamicCollectionItemGutter: new Option({
        metadata: {
            name: 'dynamicCollectionItemGutter',
            lockedOption: false,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'dynamic-collection-item-gutter',
    }),

    dynamicCollectionItemWidth: new Option({
        metadata: {
            name: 'dynamicCollectionItemWidth',
            lockedOption: false,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'dynamic-collection-item-width',
    }),

    dynamicCollectionIncludeLocations: new Option({
        metadata: {
            name: 'dynamicCollectionIncludeLocations',
            lockedOption: false,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'dynamic-collection-include-locations',
    }),

    dynamicCollectionLoader: new Option({
        metadata: {
            name: 'dynamicCollectionLoader',
            lockedOption: false,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'dynamic-collection-loader',
    }),

    ellipses: new Option({
        metadata: {
            name: 'ellipses',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'ellipses',
    }),

    googleMapCoordinates: new Option({
        metadata: {
            name: 'mapGoogleMapCooridinates',
            lockedOption: false,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'google-map-coordinates',
    }),

    googleMapStyles: new Option({
        metadata: {
            name: 'mapGoogleMapStyles',
            lockedOption: false,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'google-map-styles',
    }),

    editText: new Option({
        metadata: {
            name: 'editText',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'edit-text',
    }),

    flexDirection: new Option({
        metadata: {
            name: 'flexDirection',
            lockedOption: false,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'flex-direction',
    }),

    flexEvents: new Option({
        metadata: {
            name: 'flexEvents',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'flex-events',
    }),

    flexWrap: new Option({
        metadata: {
            name: 'flexWrap',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'flex-wrap',
    }),

    fontFamily: new Option({
        metadata: {
            name: 'fontFamily',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: false,
        },

        component: 'font-family',
    }),

    fontSize: new Option({
        metadata: {
            name: 'fontSize',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'font-size',
    }),

    fontStyle: new Option({
        metadata: {
            name: 'fontStyle',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'font-style',
    }),

    fontWeight: new Option({
        metadata: {
            name: 'fontWeight',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'font-weight',
    }),

    formEndpoint: new Option({
        metadata: {
            name: 'formEndpoint',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'form-endpoint',
    }),

    formRequestType: new Option({
        metadata: {
            name: 'formRequestType',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'form-request-type',
    }),

    hamburgerNavBreakpoint: new Option({
        metadata: {
            name: 'hamburgerNavBreakpoint',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'advanced-nav-breakpoint',
    }),

    hamburgerNavSlideDirection: new Option({
        metadata: {
            name: 'hamburgerNavSlideDirection',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'hamburger-nav-slide-direction',
    }),

    hamburgerNavSlideSpeed: new Option({
        metadata: {
            name: 'hamburgerNavSlideSpeed',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'hamburger-nav-slide-speed',
    }),

    height: new Option({
        metadata: {
            name: 'height',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'height',
    }),

    hoverTransition: new Option({
        metadata: {
            name: 'hoverTransition',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: false,
        },

        component: 'hover-transition',
    }),

    htmlIdOverride: new Option({
        metadata: {
            name: 'htmlIdOverride',
            lockedOption: true,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isLinkNew'],
            screens: [],
            isResponsive: false,
        },

        component: 'html-id-override',
    }),

    htmlTag: new Option({
        metadata: {
            name: 'htmlTag',
            lockedOption: true,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isLinkNew'],
            screens: [],
            isResponsive: false,
        },

        component: 'html-tag',
    }),

    htmlCustomAttributes: new Option({
        metadata: {
            name: 'htmlCustomAttributes',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'html-custom-attributes',
    }),

    iconSearchCollapse: new Option({
        metadata: {
            name: 'iconSearchCollapse',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'icon-search-collapse',
    }),

    iconSearchUrl: new Option({
        metadata: {
            name: 'iconSearchUrl',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'icon-search-url',
    }),

    imageFilter: new Option({
        metadata: {
            name: 'imageFilter',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'image-filter',
    }),

    imageGradient: new Option({
        metadata: {
            name: 'imageGradient',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'image-gradient',
    }),

    imageGradientOpacity: new Option({
        metadata: {
            name: 'imageGradientOpacity',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'image-gradient-opacity',
    }),

    imageSelector: new Option({
        metadata: {
            name: 'imageSelector',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'image-selector',
    }),

    inputChecked: new Option({
        metadata: {
            name: 'inputChecked',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'input-checked',
    }),

    inputName: new Option({
        metadata: {
            name: 'fieldName',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'input-name',
    }),

    ariaLabel: new Option({
        metadata: {
            name: 'ariaLabel',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'aria-label',
    }),

    ariaLabelledBy: new Option({
        metadata: {
            name: 'ariaLabelledBy',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'aria-labelled-by',
    }),

    ariaHidden: new Option({
        metadata: {
            name: 'ariaHidden',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'aria-hidden',
    }),

    accessibilityRole: new Option({
        metadata: {
            name: 'accessibilityRole',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'accessibility-role',
    }),

    inputOptions: new Option({
        metadata: {
            name: 'inputOptions',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'input-options',
    }),

    inputPlaceholder: new Option({
        metadata: {
            name: 'placeholder',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: false,
        },

        component: 'input-placeholder',
    }),

    inputValue: new Option({
        metadata: {
            name: 'defaultValue',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'input-default-value',
    }),

    labelFor: new Option({
        metadata: {
            name: 'labelFor',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'input-label-for',
    }),

    inputRequired: new Option({
        metadata: {
            name: 'inputRequired',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: false,
        },

        component: 'input-required',
    }),

    inputType: new Option({
        metadata: {
            name: 'inputType',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'input-type',
    }),

    inputValidation: new Option({
        metadata: {
            name: 'inputValidation',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: false,
        },

        component: 'input-validation',
    }),

    inputValidationMessage: new Option({
        metadata: {
            name: 'inputValidationMessage',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: false,
        },

        component: 'input-validation-message',
    }),

    isLink: new Option({
        metadata: {
            name: 'isLink',
            lockedOption: true,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isEventPage'],
            screens: [],
            isResponsive: false,
        },

        component: 'is-link',
    }),

    layerTransition: new Option({
        metadata: {
            name: 'layerTransition',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'layer-transition',
    }),

    letterSpacing: new Option({
        metadata: {
            name: 'letterSpacing',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'letter-spacing',
    }),

    lineHeight: new Option({
        metadata: {
            name: 'lineHeight',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'line-height',
    }),

    linkStyleTemplate: new Option({
        metadata: {
            name: 'linkStyleTemplate',
            lockedOption: false,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'link-style-template',
    }),

    linkBuilder: new Option({
        metadata: {
            name: 'linkBuilder',
            lockedOption: true,
            groupOption: false,
            requiredProps: ['isEventPage', 'isLinkNew'],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'link-builder',
    }),

    margin: new Option({
        metadata: {
            name: 'margin',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'margin',
    }),

    maxCharacters: new Option({
        metadata: {
            name: 'maxCharacters',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'max-characters',
    }),

    maxHeight: new Option({
        metadata: {
            name: 'maxHeight',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'max-height',
    }),

    maxWidth: new Option({
        metadata: {
            name: 'maxWidth',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'max-width',
    }),

    minHeight: new Option({
        metadata: {
            name: 'minHeight',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'min-height',
    }),

    minWidth: new Option({
        metadata: {
            name: 'minWidth',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'min-width',
    }),

    navDataSource: new Option({
        metadata: {
            name: 'navDataSource',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'nav-data-source',
    }),

    objectFit: new Option({
        metadata: {
            name: 'objectFit',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'object-fit',
    }),

    objectPosition: new Option({
        metadata: {
            name: 'objectPosition',
            lockedOption: false,
            groupOption: true,
            requiredProps: ['isBackgroundImageNew'],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'object-position',
    }),

    offset: new Option({
        metadata: {
            name: 'offset',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: false,
        },

        component: 'offset',
    }),

    opacity: new Option({
        metadata: {
            name: 'opacity',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'opacity',
    }),

    overflow: new Option({
        metadata: {
            name: 'overflow',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'overflow',
    }),

    padding: new Option({
        metadata: {
            name: 'padding',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'padding',
    }),

    placement: new Option({
        metadata: {
            name: 'placement',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'placement',
    }),

    rowShading: new Option({
        metadata: {
            name: 'rowShading',
            lockedOption: false,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'row-shading',
    }),

    searchFacet: new Option({
        metadata: {
            name: 'searchFacet',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
        },

        component: 'search-facet-options',
    }),

    calendarFacetStartDate: new Option({
        metadata: {
            name: 'calendarFacetStartDate',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
        },

        component: 'calendar-facet-start-date',
    }),

    calendarFacetDateDotColor: new Option({
        metadata: {
            name: 'calendarFacetDateDotColor',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
        },

        component: 'calendar-facet-dot-color',
    }),

    calendarFacetDateBarColor: new Option({
        metadata: {
            name: 'calendarFacetDateBarColor',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
        },

        component: 'calendar-facet-bar-color',
    }),

    calendarFacetDateDot: new Option({
        metadata: {
            name: 'calendarFacetDateDot',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
        },

        component: 'calendar-facet-dot',
    }),

    calendarFacetDateBar: new Option({
        metadata: {
            name: 'calendarFacetDateBar',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
        },

        component: 'calendar-facet-bar',
    }),

    calendarFacetDateHighlight: new Option({
        metadata: {
            name: 'calendarFacetDateHighlight',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
        },

        component: 'calendar-facet-highlight',
    }),

    calendarFacetEventPage: new Option({
        metadata: {
            name: 'calendarFacetEventPage',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
        },

        component: 'calendar-facet-event-page-url',
    }),

    calendarFacetTitle: new Option({
        metadata: {
            name: 'calendarFacetTitle',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
        },

        component: 'calendar-facet-title',
    }),

    calendarFacetWeekdays: new Option({
        metadata: {
            name: 'calendarFacetWeekdays',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
        },

        component: 'calendar-facet-weekdays',
    }),

    calendarFacetDay: new Option({
        metadata: {
            name: 'calendarFacetDay',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
        },

        component: 'calendar-facet-day',
    }),

    searchKeywordsFormId: new Option({
        metadata: {
            name: 'searchKeywordsFormId',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
        },

        component: 'search-keywords-form-id',
    }),

    skewY: new Option({
        metadata: {
            name: 'skewY',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'skew-y',
    }),

    sticky: new Option({
        metadata: {
            name: 'sticky',
            lockedOption: false,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'sticky',
    }),

    tabDockLocation: new Option({
        metadata: {
            name: 'tabDockLocation',
            lockedOption: true,
            groupOption: false,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },
        component: 'tab-dock-location',

    }),

    tableDataSource: new Option({
        metadata: {
            name: 'tableDataSource',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'table-data-source',
    }),

    textAlignment: new Option({
        metadata: {
            name: 'textAlignment',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'text-alignment',
    }),

    textDecoration: new Option({
        metadata: {
            name: 'textDecoration',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'text-decoration',
    }),

    textShadow: new Option({
        metadata: {
            name: 'textShadow',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'text-shadow',
    }),

    textTransform: new Option({
        metadata: {
            name: 'textTransform',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'text-transform',
    }),

    visibility: new Option({
        metadata: {
            name: 'visibility',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'visibility',
    }),

    width: new Option({
        metadata: {
            name: 'width',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isBackgroundImageNew', 'isHiddenInput'],
            screens: [],
            isResponsive: true,
        },

        component: 'width',
    }),

    zIndex: new Option({
        metadata: {
            name: 'zIndex',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: ['isHiddenInput'],
            screens: [],
            isResponsive: false,
        },

        component: 'z-index',
    }),

    zoom: new Option({
        metadata: {
            name: 'zoom',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'zoom',
    }),

    searchFacetValueToggle: new Option({
        metadata: {
            name: 'search-facet-value-toggle',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: true,
        },

        component: 'search-facet-value-toggle',
    }),

    advancedTabbedNavTransition: new Option({
        metadata: {
            name: 'advancedTabbedNavTransition',
            lockedOption: false,
            groupOption: true,
            requiredProps: [],
            disallowedProps: [],
            screens: [],
            isResponsive: false,
        },

        component: 'advanced-tabbed-nav-transition',
    }),

    ...optionsClient,
};
